<template>
  <div class="attribution-analysis-table-container">
    <el-table :data="getCurrentPageData" class="table">
      <el-table-column label="待归因条件" header-align="center">
        <el-table-column prop="action_type" label="待归因事件" width="120"></el-table-column>

        <el-table-column
          v-for="(item, idx) in groupBy"
          :key="`${item.val}_${idx}`"
          :prop="item.val"
          :label="item.label"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row[item.val] || '-' }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="触发情况" header-align="center">
        <el-table-column prop="totalCount" label="总触发次数"></el-table-column>
        <el-table-column prop="enabledTotalCount" label="有效触发次数"></el-table-column>
      </el-table-column>
      <el-table-column label="转化效果" header-align="center">
        <el-table-column
          prop="totalAmt"
          :label="`${eventTargetColumn.type.label || ''}${eventTargetColumn.calc.label || ''}`"
        />
        <el-table-column prop="proportion" label="贡献占比">
          <template slot-scope="scope">
            {{ formatPercent(scope.row.proportion) }}
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>

    <t-pagination
      class="footer"
      style="margin: 16px 0 0 0; text-align: right"
      :current-page="currentPage"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      :total="totalCount"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></t-pagination>
  </div>
</template>

<script>
import lodash from 'lodash';

export default {
  name: 'AttributionAnalysisTable',
  props: {
    conditionPropertyOptions: {
      type: Array,
      required: true,
    },
    eventTargetColumn: {
      type: Object,
      required: true,
    },
    analysisModelConfig: {
      type: Object,
      required: true,
    },
    listData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10, // 一页有多少条数据
      totalCount: 0, // 总共的条数
      pageSizeList: [10, 20, 50, 100, 300, 500], // 可供选择的每页大小
    };
  },
  computed: {
    groupBy() {
      let tmpGroupBy = [];
      this.analysisModelConfig.toAttributeEvent.forEach(item => {
        if (item.groupBy) {
          const findProperty = this.conditionPropertyOptions.find(i => i.propertyName === item.groupBy);
          tmpGroupBy.push({
            val: item.groupBy,
            label: findProperty ? findProperty.propertyDesc : '未知属性',
          });
        }
      });
      tmpGroupBy = lodash.uniqBy(tmpGroupBy, 'val');
      return tmpGroupBy;
    },
    getCurrentPageData() {
      const { currentPage, pageSize } = this.$data;
      const start = (currentPage - 1) * pageSize;
      const end = currentPage * pageSize;
      return this.listData.slice(start, end);
    },
  },
  watch: {
    listData: {
      handler() {
        this.initData();
      },
      deep: true,
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.currentPage = 1;
      this.totalCount = this.listData.length;
    },

    handleSizeChange(size) {
      this.pageSize = size;
    },

    handleCurrentChange(page) {
      this.currentPage = page;
    },

    formatPercent(value) {
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(value)) return value;
      return `${(+value * 100).toFixed(2)}%`;
    },
  },
};
</script>

<style lang="less" scoped>
.attribution-analysis-table-container {
  flex: 1;
  height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;

  .table {
    flex: 1;
    overflow: auto;
  }
}
</style>
